/**
 * Status value type for task status tracking.
 * Matches TaskStatus from the API: 'Open' | 'Solved' | 'Closed', or null for unset.
 */
export type StatusValue = 'Open' | 'Solved' | 'Closed' | null;

/**
 * Individual status option configuration.
 */
export interface StatusOption {
  /** The status value */
  value: StatusValue;
  /** Translation key for the label */
  labelKey: string;
  /** CSS class modifier for styling */
  modifier: string;
}

/**
 * Default status options with their configurations.
 * Note: 'Solved' is displayed as "Resolved" via translation keys.
 */
export const STATUS_OPTIONS: StatusOption[] = [
  { value: 'Open', labelKey: 'status-dropdown.open', modifier: 'open' },
  { value: 'Solved', labelKey: 'status-dropdown.resolved', modifier: 'resolved' },
  { value: 'Closed', labelKey: 'status-dropdown.closed', modifier: 'closed' },
];
